__turbopack_context__.v({
  "action-buttons": "advertiser-info-section-module-scss-module__f_4T2a__action-buttons",
  "buttons-box": "advertiser-info-section-module-scss-module__f_4T2a__buttons-box",
  "seller-info-content": "advertiser-info-section-module-scss-module__f_4T2a__seller-info-content",
  "stickiness": "advertiser-info-section-module-scss-module__f_4T2a__stickiness",
  "with-reply-time": "advertiser-info-section-module-scss-module__f_4T2a__with-reply-time",
});
